import { Stack, CircularProgress } from "@mui/material";

export const LoadingProgress = ()  => {
  return (
    <Stack alignItems="center" justifyContent="center" height="100vh">
      <CircularProgress size={64} />
    </Stack>
  );
};
